import angular from 'angular';
import { getZendeskUrl, getMyTicketsUrl } from '@/shared/components/ZendeskHelp';

angular.module('cloudX').directive('cxZendeskHelp', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: `<a ng-href="{{formattedUrl}}"
                    target="_blank"
                    rel="noopener noreferrer help external"
                    class="clickable clickable-icon zendesk-help"
                    title="{{(\'OpenZendeskArticle\' | translate)}}">
                  <i class="fa fa-question-circle-o"></i>
                </a>`,
      scope: {
        article: '@',
        getArticle: '&',
        section: '@',
        anchor: '@',
      },
      controller: [
        '$scope',
        '$translate',
        '$window',
        '$rootScope',
        function($scope, $translate, $window, $rootScope) {
          $scope.formatUrl = () => {
            $scope.formattedUrl = $scope.article
              ? getZendeskUrl($scope.article, $translate.use(), false, $scope.anchor)
              : $scope.section
              ? getZendeskUrl($scope.section, $translate.use(), true)
              : getZendeskUrl($scope.getArticle(), $translate.use(), false, $scope.anchor);
          };

          $scope.formatUrl();

          //Listen to global language change event
          var deregistration = $rootScope.$on('$translateChangeSuccess', function() {
            $scope.formatUrl();
          });
          $scope.$on('$destroy', deregistration);
        },
      ],
    };
  },
]);
